import { render, staticRenderFns } from "./BulletRow.vue?vue&type=template&id=70bfe06e&scoped=true&"
import script from "./BulletRow.vue?vue&type=script&lang=js&"
export * from "./BulletRow.vue?vue&type=script&lang=js&"
import style0 from "./BulletRow.vue?vue&type=style&index=0&id=70bfe06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bfe06e",
  null
  
)

export default component.exports